module.exports = __webpack_public_path__ + "img/Slide33.948140d1.png";